import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DestroyableComponent } from 'src/app/core/destroyable.component';

type ReturnObservableFn<T> = () => Observable<T>;

@Component({
  selector: 'sky-async-button[action]',
  template: `
    <button
      [class.disabled]="disabled || loading"
      (click)="handleClick($event)"
      class="flex justify-center items-center sky-btn-sky-blue w-full"
    >
      <sky-spinner *ngIf="loading" class="mr-2" size="sm"></sky-spinner>
      <ng-content></ng-content>
    </button>
  `,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
})
export class AsyncButtonComponent<T> extends DestroyableComponent {
  @Input() public action!: Observable<T> | ReturnObservableFn<T>;
  @Input() public disabled = false;
  @Output() public handle = new EventEmitter<T>();

  public loading = false;

  // public get button(): ButtonClass {
  //   return BUTTON_COLOR_MAP.get(this.color) as ButtonClass;
  // }

  // public ngOnInit() {
  //   this.bgClass = `sky-btn-sky-${this.color}`;
  // }

  public handleClick(event: Event): void {
    event.preventDefault();
    event.stopPropagation();

    if (this.disabled) {
      return;
    }

    const action = typeof this.action === 'function' ? this.action() : this.action;

    this.loading = true;
    action.pipe(takeUntil(this._destroyed$)).subscribe(
      effect => {
        this.loading = false;
        this.handle.emit(effect);
      },
      (response: any) => {
        if (this.isHttpErrorResponse(response)) {
          alert(
            `Wystąpił błąd: Błąd: "${response.error.error}"; Status: ${response.status}; Wiadomość "${response.error.message}". Więcej szczegółów w konsoli w narzędziach deweloperskich przeglądarki`
          );
          console.error(response);
        } else {
          alert('Wystąpił nieznany błąd. Sprawdź konsolę w narzędziach deweloperskich przeglądarki');
          console.error(response);
        }
        this.loading = false;
      },
      () => {
        this.loading = false;
      }
    );
  }

  private isHttpErrorResponse(error: any): error is HttpErrorResponse {
    return error.error?.error && error.error.message && error.headers && error.status && error.name;
  }
}
